const i18nData = {
  en: { k001: 'Start Video Chat,\nIn just 1 second', k002: 'Download', copied: 'Copied' },
  ar: { k001: 'ابدأ محادثة فيديو،\nفي ثانية واحدة', k002: 'تنزيل', copied: 'منسوخ' },
  az: { k001: 'Video söhbətə başla,\nYalnız 1 saniyə içində', k002: 'Yüklə', copied: 'Kopyalandı' },
  bn: { k001: 'ভিডিও চ্যাট শুরু করুন,\nমাত্র ১ সেকেন্ডে', k002: 'ডাউনলোড', copied: 'কপি হয়েছে' },
  da: { k001: 'Start videochat,\npå kun 1 sekund', k002: 'Download', copied: 'Kopieret' },
  de: { k001: 'Starte Video-Chat,\nin nur 1 Sekunde', k002: 'Download', copied: 'Kopiert' },
  es: { k001: 'Inicia videochat,\nen solo 1 segundo', k002: 'Descargar', copied: 'Copiado' },
  fa: { k001: 'چت ویدیویی را شروع کنید،\nدر فقط ۱ ثانیه', k002: 'دانلود', copied: 'کپی شد' },
  fr: { k001: 'Lancez le chat vidéo,\nen seulement 1 seconde', k002: 'Télécharger', copied: 'Copié' },
  he: { k001: "התחל צ'אט וידאו,\nבשנייה אחת", k002: 'הורד', copied: 'הועתק' },
  id: { k001: 'Mulai obrolan video,\nhanya dalam 1 detik', k002: 'Unduh', copied: 'Disalin' },
  it: { k001: 'Avvia videochat,\nin solo 1 secondo', k002: 'Scarica', copied: 'Copiato' },
  ms: { k001: 'Mulakan sembang video,\nhanya dalam 1 saat', k002: 'Muat turun', copied: 'Disalin' },
  pl: { k001: 'Rozpocznij czat wideo,\nw zaledwie 1 sekundę', k002: 'Pobierz', copied: 'Skopiowano' },
  pt: { k001: 'Inicie o videochat,\nem apenas 1 segundo', k002: 'Baixar', copied: 'Copiado' },
  ro: { k001: 'Începe un videochat,\nîn doar 1 secundă', k002: 'Descarcă', copied: 'Copiat' },
  ru: { k001: 'Начните видеочат,\nвсего за 1 секунду', k002: 'Скачать', copied: 'Скопировано' },
  th: { k001: 'เริ่มแชทวิดีโอ,\nในเวลาเพียง 1 วินาที', k002: 'ดาวน์โหลด', copied: 'คัดลอกแล้ว' },
  tr: { k001: 'Görüntülü sohbeti başlat,\nsadece 1 saniyede', k002: 'İndir', copied: 'Kopyalandı' },
  uk: { k001: 'Почніть відеочат,\nлише за 1 секунду', k002: 'Завантажити', copied: 'Скопійовано' },
  vi: { k001: 'Bắt đầu trò chuyện video,\nchỉ trong 1 giây', k002: 'Tải xuống', copied: 'Đã sao chép' },
}

const rtlLangs = { ar: true, fa: true, he: true }

export default {
  data() {
    return {
      isRtl: false,
      prevLang: '',
      prevDir: '',
      copiedText: '',
      titleHtml: '',
      btnText: '',
    }
  },
  created() {
    const lang = this.getI18nLang()
    const t = i18nData[lang]
    this.copiedText = t.copied
    this.titleHtml = t.k001.replace(/\n/g, '<br />')
    this.btnText = t.k002
    this.isRtl = !!rtlLangs[lang]
  },
  methods: {
    getI18nLang() {
      const query = (this.$route && this.$route.query) || {}
      return i18nData[query.lang] ? query.lang : 'en'
    },
    applyLangDir() {
      const html = document.documentElement
      this.prevLang = html.getAttribute('lang') || ''
      this.prevDir = html.getAttribute('dir') || ''
      const lang = this.getI18nLang()
      html.setAttribute('lang', lang)
      if (rtlLangs[lang]) {
        html.setAttribute('dir', 'rtl')
      } else {
        html.removeAttribute('dir')
      }
    },
    restoreLangDir() {
      const html = document.documentElement
      if (this.prevLang) {
        html.setAttribute('lang', this.prevLang)
      } else {
        html.removeAttribute('lang')
      }
      if (this.prevDir) {
        html.setAttribute('dir', this.prevDir)
      } else {
        html.removeAttribute('dir')
      }
    },
  },
}
